import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TemplateEntityPeriodicityEnum } from '@zaoblako/shared/common/enums/template.entity.periodicity.enum';

/** Localized display names for {@link TemplateEntityPeriodicityEnum} enumeration values */
export const TemplateEntityPeriodicityEnumI18n: Record<I18nLocalesEnum, Record<TemplateEntityPeriodicityEnum, string>> = {
  [I18nLocalesEnum.EN_US]: {
    [TemplateEntityPeriodicityEnum.NONE]: 'none',
    [TemplateEntityPeriodicityEnum.ONCE]: 'once',
    [TemplateEntityPeriodicityEnum.ON_WORK_DAYS]: 'on work days',
    [TemplateEntityPeriodicityEnum.DAILY]: 'daily',
    [TemplateEntityPeriodicityEnum.WEEKLY]: 'weekly',
    [TemplateEntityPeriodicityEnum.MONTHLY]: 'monthly',
    [TemplateEntityPeriodicityEnum.QUARTERLY]: 'quarterly',
    [TemplateEntityPeriodicityEnum.ANNUALLY]: 'annually',
  },
  [I18nLocalesEnum.RU_RU]: {
    [TemplateEntityPeriodicityEnum.NONE]: 'без периодичности',
    [TemplateEntityPeriodicityEnum.ONCE]: 'один раз',
    [TemplateEntityPeriodicityEnum.ON_WORK_DAYS]: 'по будням',
    [TemplateEntityPeriodicityEnum.DAILY]: 'ежедневно',
    [TemplateEntityPeriodicityEnum.WEEKLY]: 'еженедельно',
    [TemplateEntityPeriodicityEnum.MONTHLY]: 'ежемесячно',
    [TemplateEntityPeriodicityEnum.QUARTERLY]: 'ежеквартально',
    [TemplateEntityPeriodicityEnum.ANNUALLY]: 'ежегодно',
  },
};
